import React, { Component } from 'react';
import styled from 'styled-components';
import './App.css';
import Form from './modules/Form';
import Subtotal from "./modules/Subtotal";
import Accordion from './modules/Accordion';
import { data } from './data';

const StyledApp = styled.div`
  font-family: "Roboto", Arial, sans-serif;
  font-size: 15px;

  h1 {
    font-weight: 300;
  }

  h2 {
    width: 50%;
    margin: auto;
    text-align: center;
    padding-bottom: 10px;
    font-weight: 300;
  }

  .title {
    padding-top: 2vh;
    text-align: center;
    font-weight: 300;
  }

  .input {
    text-align: center;
  }

  .card {
    padding-top: 5vh;
    width: 50%;
    margin: auto;
    background-color: #fefefe;
    border: 1px solid #dae0e0;
    border-radius: 3px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
    margin-bottom: 20px;
    padding: 25px;
  }

  @media (max-width: 500px) {
    .card {
      padding: 20px;
    }
  }
`;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      numberVehicles: 10,
      costPerBooklet: 30,
      timeProcess: 5,
      timeBetween: 14,
      timeLast: 90,
      timeOperational: 365,
      timeDown: 3,
      hourlyWage: 25
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  calcPaperHoursProcess() {
    const totalMin = this.state.numberVehicles * this.state.timeOperational * this.state.timeProcess
    return this.checkForZeroValue(totalMin/60)
  }

  calcPaperHoursDistAndColl() {
    const timesColl = this.state.timeOperational / this.state.timeBetween
    const timesDist = this.state.timeOperational / this.state.timeLast
    // Average time spent collecting and distributing is 5 minutes
    return this.checkForZeroValue((timesColl + timesDist) * this.state.numberVehicles /12) 
  }

  calcPaperHoursLatency() {
    const timesColl = this.state.timeOperational * 0.01
    return this.checkForZeroValue(timesColl * this.state.timeBetween * 12)
  }

  calcPaperHoursFleetDowntime() {
    const downtime = this.state.numberVehicles *(this.state.timeDown + this.state.timeBetween/5) *24
    return this.checkForZeroValue(downtime)
  }

  calcCircleChekHoursFleetDowntime() {
    const downtime = this.state.numberVehicles *(this.state.timeDown) *24
    return this.checkForZeroValue(downtime)
  }

  calcPaperHours() {
    var sum = this.calcPaperHoursProcess()
    sum += this.calcPaperHoursDistAndColl()
    //sum += this.calcPaperHoursLatency()
    //sum += this.calcPaperHoursFleetDowntime()
    return this.checkForZeroValue(sum)
  }

  calcCircleChekHours() {
    return 0
  }

  calcDiffHours() {
    return this.checkForZeroValue(this.calcPaperHours() - this.calcCircleChekHours())
  }

  calcPaperDollarsPurchase() {
    const total = Math.ceil(this.state.timeOperational / this.state.timeLast) * this.state.numberVehicles * this.state.costPerBooklet
    return this.checkForZeroValue(total)
  }

  calcCircleChekDollarsPurchase() {
    // $3 per month
    const total = Math.ceil(this.state.timeOperational / 30) * this.state.numberVehicles * 2
    return this.checkForZeroValue(total)
  }

  calcPaperDollarsProcess() {
    const total = (this.calcPaperHoursProcess() + this.calcPaperHoursDistAndColl()) * this.state.hourlyWage
    return this.checkForZeroValue(total)
  }

  calcPaperDollarsDowntime() {
    const total = this.calcPaperHoursFleetDowntime() / 24 * 468
    return this.checkForZeroValue(total)
  }

  calcCircleChekDollarsDowntime() {
    const total = this.calcCircleChekHoursFleetDowntime() / 24 * 468
    return this.checkForZeroValue(total)
  }

  calcPaperDollarsLatency() {
    const total = this.calcPaperHoursLatency() / 48 * 121 
    return this.checkForZeroValue(total)
  }

  calcPaperDollars() {
    var sum = this.calcPaperDollarsPurchase()
    sum += this.calcPaperDollarsProcess()
    //sum += this.calcPaperDollarsDowntime()
    //sum += this.calcPaperDollarsLatency()
    return this.checkForZeroValue(sum)
  }

  calcCircleChekDollars() {
    return this.checkForZeroValue(this.calcCircleChekDollarsPurchase())
  }

  calcDiffDollars() {
    return this.checkForZeroValue(this.calcPaperDollars() - this.calcCircleChekDollars())
  }

  checkForZeroValue(data) {
    return (!this.state.numberVehicles ? 0 :  Number(data.toFixed(2)));
  }

  handleInputChange(e) {
    if (e.target.type === "number") {
      e.target.value = Number(e.target.value);

      if (e.which < 48 || e.which > 57) {
        e.preventDefault();
      }

      e.target.value = (e.target.value.length > 5) ? e.target.value.substring(0, 5) : e.target.value;
    } 
    this.setState({
      [e.target.name]: e.target.value
    })    
  }

  render() {

    const inputValues = {
      numberVehicles: this.state.numberVehicles,
      costPerBooklet: this.state.costPerBooklet,
      timeProcess: this.state.timeProcess,
      timeBetween: this.state.timeBetween,
      timeLast: this.state.timeLast,
      timeOperational: this.state.timeOperational,
      timeDown: this.state.timeDown,
      hourlyWage: this.state.hourlyWage
    }

    return <StyledApp>
      <section className='title'>
        <h1>CircleChek ROI Calculator</h1>
      </section>
      <section className="input">
          <h2>Input your company's details</h2>
          <Form handleInputChange={this.handleInputChange} inputValues={inputValues} />
          <a className="href" href="https://app.circlechek.com" target="_blank" rel="noopener noreferrer">
            Signup for a free trial today! <br/><br/>
          </a>
          
          <Accordion
            cardHeadingLabel="Time Saved"
            cardHeadingValue={this.calcDiffHours()}
            units="Hours/Year"
            rows={[
              {
                rowLabel: "Processing and Analyzing Inspections",
                rowCalc: `${this.state.numberVehicles} Vehicles x ${this.state.timeOperational} Operational Days x ${this.state.timeProcess} Minutes Spent Per Inspection =`,
                rowDesc: "This total is the time spent processing and analyzing inspections.",
                manualValue: this.calcPaperHoursProcess(),
                resolverValue: 0
              },
              {
                rowLabel: "Distributing and Collecting inspections",
                rowCalc:`${this.state.numberVehicles} Vehicles x (${Math.ceil(this.state.timeOperational / this.state.timeBetween)} Distributions + ${Math.ceil(this.state.timeOperational / this.state.timeLast)} Collections) x 5 Minutes Spent Per Step = `,
                rowDesc: "This total is the time spent distributing and collecting inspections.",
                manualValue: this.calcPaperHoursDistAndColl(),
                resolverValue: 0
              },
              // {
              //   rowLabel: "Total response latency for vehicle repairs and downtime",
              //   manualValue: this.calcPaperHoursLatency(),
              //   resolverValue: 0
              // },
              // {
              //   rowLabel: "Total overall fleet downtime",
              //   manualValue: this.calcPaperHoursFleetDowntime(),
              //   resolverValue: this.calcCircleChekHoursFleetDowntime()
              // }
            ]}
            manualTotal={this.calcPaperHours()}
            resolverTotal={this.calcCircleChekHours()}
          />
        
        
          <Accordion
            cardHeadingLabel="Money Saved"
            cardHeadingValue={this.calcDiffDollars()}
            units="$/Year"
            rows={[
              {
                rowLabel: "Cost of Inspection Booklets",
                rowCalc: `${this.state.numberVehicles} Vehicles x ${Math.ceil(this.state.timeOperational / this.state.timeLast)} Booklets Filled per Vehicle in a Year x $${this.state.costPerBooklet} Cost Per Booklet =`,
                rowDesc: `CircleChek costs $2 per vehicle per month. Save $${Math.abs(this.calcPaperDollarsPurchase() - this.calcCircleChekDollarsPurchase())} by switching.`,
                manualValue: this.calcPaperDollarsPurchase(),
                resolverValue: this.calcCircleChekDollarsPurchase()
              },
              {
                rowLabel: "Processing, Analyzing, Collecting, and Distributing Inspections",
                rowCalc: `(${Math.ceil(this.calcPaperHoursProcess())} Hours Processing Paperwork + ${Math.ceil(this.calcPaperHoursDistAndColl())} Hours Circlulating Paperwork) x $${this.state.hourlyWage}/Hour Wage =`,
                rowDesc: "This is what you pay a manager to complete paperwork that CircleChek has automated.",
                manualValue: this.calcPaperDollarsProcess(),
                resolverValue: 0
              },
              // {
              //   rowLabel: "Overall repair response latency costs",
              //   manualValue: this.calcPaperDollarsLatency(),
              //   resolverValue: 0,
              // },
              // {
              //   rowLabel: "Overall downtime cost for fleet",
              //   manualValue: this.calcPaperDollarsDowntime(),
              //   resolverValue: this.calcCircleChekDollarsDowntime(),
              // },
            ]}
            manualTotal={this.calcPaperDollars()}
            resolverTotal={this.calcCircleChekDollars()}
          />
      </section>
    </StyledApp>;
  }
}

export default App;
